var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoodAwfulIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F4B2D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6963 14.6307C14.3788 13.7776 15.6237 13.6392 16.4768 14.3218L21.4225 18.2783C22.2756 18.9608 22.414 20.2057 21.7314 21.0588C21.0489 21.912 19.804 22.0503 18.9509 21.3678L14.0052 17.4113C13.1521 16.7288 13.0137 15.4839 13.6963 14.6307Z",
    fill: "#4C555F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5889 18.062C15.5889 16.9402 16.4983 16.0308 17.6201 16.0308C18.7419 16.0308 19.6514 16.9402 19.6514 18.062V22.1245C19.6514 23.2463 18.7419 24.1558 17.6201 24.1558C16.4983 24.1558 15.5889 23.2463 15.5889 22.1245V18.062Z",
    fill: "#4C555F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2834 15.5157C38.9308 16.3958 38.7422 17.634 37.8621 18.2815L32.7604 22.0346C31.8803 22.682 30.642 22.4934 29.9946 21.6133C29.3472 20.7333 29.5358 19.495 30.4158 18.8476L35.5176 15.0944C36.3976 14.447 37.6359 14.6356 38.2834 15.5157Z",
    fill: "#4C555F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9136 18.708C31.9136 17.5862 32.823 16.6768 33.9448 16.6768C35.0667 16.6768 35.9761 17.5862 35.9761 18.708V22.7705C35.9761 23.8923 35.0667 24.8018 33.9448 24.8018C32.823 24.8018 31.9136 23.8923 31.9136 22.7705V18.708Z",
    fill: "#4C555F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0532 36.7805C14.0532 35.6879 14.9389 34.8022 16.0315 34.8022H36.344C37.4365 34.8022 38.3222 35.6879 38.3222 36.7805C38.3222 37.8731 37.4365 38.7588 36.344 38.7588H16.0315C14.9389 38.7588 14.0532 37.8731 14.0532 36.7805Z",
    fill: "#4C555F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoodAwfulIcon);
export default __webpack_public_path__ + "static/media/MoodAwfulIcon.4ba61103257f6b57665cf98fd3bb1103.svg";
export { ForwardRef as ReactComponent };